<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>Manage Setup Access</h2>
            <span class="sub">Manage setup access for this user</span>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body">
        <div class="mp-toggle-list m-0">
            <!-- Allow this user to manage billing -->
            <section class="mp-subpanel mp-row" *ngIf="showBilling">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div>
                        <div class="title">Allow this user to manage billing?</div>
                        <p class="sub">Enables licenses & billing option in the setup for this user</p>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-inputSwitch [(ngModel)]="billingUser" [disabled]="!isBillingEditable"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Allow this user to access AI features -->
            <section class="mp-subpanel mp-row" *ngIf="showAi">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div>
                        <div class="title">Allow this user to access AI features?</div>
                        <p class="sub">Enables AI features in the setup for this user</p>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-inputSwitch [(ngModel)]="aiAccess"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Allow this user to go offline -->
            <section class="mp-subpanel mp-row" *ngIf="showOffline">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div>
                        <div class="title">Allow this user to go offline?</div>
                        <p class="sub">Enables users to toggle between offline/online mode on the mobile app</p>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-inputSwitch [(ngModel)]="offlineEnable"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="modalRef.hide()">Cancel</button>
        <p-button
            type="button"
            [label]="translate?.general.buttons.save.singular"
            styleClass="h-32"
            [disabled]="saving"
            (onClick)="onSave()"></p-button>
    </div>
</div>

<p-confirmDialog
    [style]="{ width: '30vw' }"
    [baseZIndex]="11000"
    maskStyleClass="setup-access-confirm-mask"
    key="setupAccessOffline"
    [appendTo]="'body'">
</p-confirmDialog>
